<div class="parent">
  <nav class=" navbar navbar-expand-lg navbar-light ">
    <div class="container-fluid">
      <div id="set1">
        <ul class="navbar-nav">
          <li>
            <button class="btn" (click)="saveClick()" title="Saves all data in current screen">
              <i class='fa fa-save fa-flip-vertical fa-2x' style='color:#b57af0'></i>
              <figcaption>Save</figcaption>
            </button>
          </li>
          <li>
            <button class="btn" (click)="refreshClick()" title="Refreshes all data in current screen">
              <i class='fa fa-refresh fa-2x' style='color: #1aca17'></i>
              <figcaption>Refresh</figcaption>
            </button>
          
          </li>
        </ul>
        <div class="footer">
          Data
        </div>
      </div>
      <div id="set2" *ngIf="dynamicTabsService.selectedTabData.type=='policy'" style="margin-right:21px !important;">
        <ul class="navbar-nav  d-flex flex-row align" >
          <li class="nav-item me-3 me-lg-0">
            <button class="btn" (click)="deleteClick()" title="Delete">
              <i class="fa fa-trash fa-2x" aria-hidden="true" style='color:#0d0d0d'></i>
              <figcaption>Delete</figcaption>
            </button>
          </li>
          <li class="nav-item me-3 me-lg-0">
            <button class="btn" (click)="renewClick()" title="Renew policy">
              <i class="fa fa-retweet fa-rotate-90 fa-2x" style="color:#1aca17"></i>
              <figcaption>Renew Policy</figcaption>
            </button>
            <!-- <p style="margin-right:10px;">Actions</p> -->
          </li>
        </ul>
        <div class="footer" style="margin-right:1090px !important;">
          Actions
        </div>
      </div>
    </div>
  </nav>
  

  <div class="sidebar-parent ">
    <div class="sidebar" [ngClass]="{ 'collapsed':isCollapsed}">
      <app-sidenav [navData]=navbarData (onToggleSideNav)="onToggleSideNav($any($event))">
      </app-sidenav>
    </div>
    <div class="main-content">
      <app-body #bodyComponent [collapsed]="isSideNavCollapsed" [screenWidth]="screenWidth"></app-body>
    </div>
  </div>
</div>